import { useI18n } from "../lib/i18n";
import { useStore } from "../lib/store";
import { MessageCircle } from "lucide-react";

export const WhatsAppFloat = () => {
  const { t } = useI18n();
  const s = useStore();
  if (s.whatsappEnabled === false || !s.whatsappNumber) return null;
  const digits = s.whatsappNumber.replace(/[^0-9]/g, "");
  const href = `https://wa.me/${digits}?text=${encodeURIComponent(s.whatsappMessage || "")}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label={t("wa_float_label")}
      className="fixed bottom-5 right-5 z-50 group flex items-center gap-2 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 pl-4 pr-5 py-3.5 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
      <MessageCircle size={22} className="relative" />
      <span className="relative hidden sm:inline text-sm font-medium">
        {t("wa_float_label")}
      </span>
    </a>
  );
};
